import React from 'react';
import IndexedSearchCreate from '../components/indexed-search-create';
import Layout from '../components/layout';
import LinkButton from '../components/link-button';
import PageHeader from '../components/page-header';
import './page.css';

const IndexedSearchCreatePage = () => {
  return (
    <Layout>
      <div className="page">
        <PageHeader
          title="Créer des recherches"
        />

        <div className="page_actions">
          <LinkButton
            className="page_action-button"
            icon="arrow_back"
            label="Retour"
            to="/recherches-indexees"
            theme="danger"
          />
        </div>

        <IndexedSearchCreate />
      </div>
    </Layout>
  );
};

export default IndexedSearchCreatePage;
